import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { UserState } from "../../types-interfaces/interfaces";
import NotAllow from "./NotAllow";
import { useEffect, useState } from "react";

export default function DomGuardian(props:{element: JSX.Element | undefined, profileAllowed: number[] | undefined}) {
  const [loading, setLoading] = useState(true); 
  const user = useSelector<RootState, UserState>((state) => state.userState);
  
  useEffect(() => {  setTimeout(() => {
    setLoading(false);
  }, 2000);},[user])
  
  const Component: JSX.Element = 
    ( props.element && !loading &&
      user.currentSession?.isAuthenticated &&
      props.profileAllowed &&
      props.profileAllowed.filter(p => user.profiles.indexOf(p) > -1).length > 0 ) ?
        props.element :
        <NotAllow/>;

  return Component;
}
